"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toRegion = exports.Region = void 0;
exports.Region = {
    us: 'us',
    jp: 'jp',
    gl: 'gl',
};
const toRegion = (value) => {
    if (value === 'us' || value === 'jp' || value === 'gl') {
        return value;
    }
    throw new Error();
};
exports.toRegion = toRegion;
exports.default = exports.Region;
